import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DeviceOPEEnum} from "./DeviceOPEEnum";

class O {
  devices: DeviceDTO[];

  constructor() {
    this.devices = [];
  }

}

class DeviceDTO {
  partitionId!: number;
  id!: number;
  name!: string;
  online!: boolean;
}


/**
 * O Inner Class
 */
class I {
  partitionId!: number;
}

export class GetDevicesCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(DeviceOPEEnum.GetDevices);
    this.i = new I();
    this.o = new O();
  }
}
